import { render, staticRenderFns } from "./ViewProducts.vue?vue&type=template&id=6c32154e&scoped=true"
import script from "./ViewProducts.vue?vue&type=script&lang=js"
export * from "./ViewProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c32154e",
  null
  
)

export default component.exports